<div class="select-audio-option-wrapper">
    <app-button class="icon" (click)="playAudio()">
        <i class="fas fa-volume-up"></i>
    </app-button>

    <mat-form-field>
        @if (!value) {
        <span class="mat-form-placeholder" i18n>Klik hier</span>
        }

        <mat-select
            [(ngModel)]="value"
            name="option"
            (ngModelChange)="valueChanged()"
        >
            @for (option of options; track option) {
            <mat-option [value]="option.value">
                {{ option.name }}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <bbvms-audio
        hidden
        [data-audio-id]="value"
        class="asset--small"
    ></bbvms-audio>
</div>
